var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
/**
 * @desc make style with options
 */
import { getPadding } from '@byted/light-render/lib/RichText/flexlayout';
import * as lodash from './lodash';
export { getPadding };
var commonOptionKeys = [
    'opacity',
    'shadowBlur',
    'shadowColor',
    'shadowOffsetX',
    'shadowOffsetY',
    'cursor',
    'pointerEvents',
    'blendMode',
    'draggable',
];
var textStyleOptionKeys = __spreadArrays(commonOptionKeys, [
    'color',
    'fontFamily',
    'fontSize',
    'lineHeight',
    'fontWeight',
    'fontVariant',
    'opacity',
    'textAlign',
    'textBaseline',
    'textStrokeWidth',
    'textStrokeColor',
    'rich',
]);
var textStyleMap = {
    color: 'fill',
    textStrokeWidth: 'lineWidth',
    textStrokeColor: 'stroke',
};
var lineStyleOptionKeys = __spreadArrays(commonOptionKeys, [
    'lineWidth',
    'stroke',
    'strokeOpacity',
    'lineDash',
    'lineCap',
    'lineJoin',
    'miterLimit',
    'borderRadius'
]);
var shapeStyleOptionKeys = __spreadArrays(lineStyleOptionKeys, [
    'fill',
    'fillOpacity',
    'round',
]);
/**
 * @param option object to pick
 * @param keys keys to pick
 */
export function pickObjByKeys(option, keys, keyMap) {
    if (keyMap === void 0) { keyMap = {}; }
    if (!option) {
        return {};
    }
    var ret = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var attr = keys_1[_i];
        var val = option[attr];
        if (!(lodash.isNull(val) || lodash.isUndefined(val))) {
            var key = attr;
            if (keyMap[attr]) {
                key = keyMap[attr];
            }
            ret[key] = val;
        }
    }
    return ret;
}
export function getLineStyle(option) {
    return pickObjByKeys(option, lineStyleOptionKeys);
}
/**
 * get text conf for Text Element
 */
export function getTextStyle(option) {
    return pickObjByKeys(option, textStyleOptionKeys, textStyleMap);
}
export function getShapeStyle(option) {
    return pickObjByKeys(option, shapeStyleOptionKeys);
}
/**
 *
 * @param padding css padding property
 */
export function getSidePadding(padding, side) {
    var sidePadding = getPadding(padding);
    var sideMap = {
        top: 'paddingTop',
        left: 'paddingLeft',
        right: 'paddingRight',
        bottom: 'paddingBottom',
    };
    return sidePadding[sideMap[side]];
}
export function getSymbolSize(size) {
    if (lodash.isNumber(size)) {
        return [size, size];
    }
    if (lodash.isArray(size)) {
        return size;
    }
}
